package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.adyen_store


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("listAdyenStores")
    val listAdyenStores: List<AdyenStores?>?,
    @SerialName("__typename")
    val typename: String?
)